import { c as _c } from "react/compiler-runtime";
import type React from 'react';
export type SectionHeaderProps = {
  children?: React.ReactNode;
  subtitle: string;
  title: string;
};
const SectionHeader = t0 => {
  const $ = _c(10);
  const {
    children,
    subtitle,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h3 className="text-heading-5 text-primary">{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subtitle) {
    t2 = <p className="text-body-2 text-secondary">{subtitle}</p>;
    $[2] = subtitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col gap-1">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children || $[8] !== t3) {
    t4 = <header className="flex flex-col items-start gap-3 mb-4 md:flex-row md:items-center md:justify-between md:gap-0">{t3}{children}</header>;
    $[7] = children;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default SectionHeader;